import React, { useContext } from 'react'
import { PageLocaleContext } from '../../../Layouts/index';
import SEO from '../../SEO';
import SectionHero from '../../SectionHero/SectionHero';
import PricingItems from './components/PricingItems/PricingItems';
import FeaturesTable from './components/FeaturesTable/FeaturesTable';
import QuestionAnswer from './components/QuestionAnswer/QuestionAnswer';

import { pagePricingData } from './constants';
import './pricing.scss'
import '../../../sass/components/_table.scss'



const Pricing = () => {
  const { langProperty } = useContext(PageLocaleContext) 
  const curLangKey = langProperty.currentLangKey // current language key
  const data = pagePricingData[langProperty.currentLangKey] // uncomment later

  
  return (
    <div className={`page-pricing ${curLangKey}`}>
    <SEO
      title='Pricing | Delight'
      description="Transform your user experience with voice"
    />
      <SectionHero 
        pretitle={ data.sectionHero.pretitle } 
        title={ data.sectionHero.title }
      >
        <PricingItems currentLangKey={curLangKey} />
      </SectionHero>
      <div className="page-pricing__section-comparison">
        <div className="fullwidth-section-container-01">
          <div className="fullwidth-section-container-02">
            <h3 className="header-h3">{data.sectionComparison.title}</h3>
            <FeaturesTable currentLangKey={curLangKey}/>
          </div>
        </div>
      </div>
      <div className="page-pricing__section-qa">
        <h3 className="header-h3">{data.sectionQa.title}</h3>
        {data.sectionQa.qaSets.map(qa => (
          <QuestionAnswer key={qa.q} q={qa.q} ans={qa.a} currentLangKey={curLangKey}/>      
        ))}
      </div>
    </div>
  )
}

export default Pricing
